import { Box, Button, IconButton, Stack, Typography } from "@mui/material";
import { GroupType } from "../../types/group.type";
import { HEADER_HEIGHT } from "../../utils/ui.constants";
import Options from "./components/Options";
import { useEffect, useState } from "react";
import { LuFilter } from "react-icons/lu";
import { asyncGetList } from "../../utils/httpRequests";
import { useSelector } from "react-redux";
import { useAlertContext } from "../../contexts/alert/AlertProvider";
import TableClient from "../../components/common/tableapp/TableClient";
import Tablepagination from "../../components/common/tableapp/TablePagination";
import { numeralCustom } from "../../utils/helpers";

interface IGroupBase {
  group: GroupType;
}

const heights = {
  header: HEADER_HEIGHT,
  py: "32px",
  topList: "50px",
  pagination: "42px",
  sumary: "30px",
};
const widthes = {
  filter: "350px",
};

function GroupBase({ group }: IGroupBase) {
  const { showAlert } = useAlertContext();
  const token = useSelector((state: any) => state.auth.token);
  const [load, setLoad] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [expandFilter, setExpandFilter] = useState<boolean>(false);
  const [filter, setFilter] = useState<{ [key: string]: any }>({});
  const [data, setData] = useState<any[]>([]);
  const [sumary, setSumary] = useState<{
    min: number;
    max: number;
    average: number;
    median: number;
  }>({
    min: 0,
    max: 0,
    average: 0,
    median: 0,
  });
  const [paginationOption, setPaginationOption] = useState<{
    page: number;
    limit: number;
    totalRows: number;
  }>({
    limit: 20,
    page: 1,
    totalRows: 0,
  });

  const getListData = async () => {
    try {
      if (loading) return;
      setLoading(true);
      const condition: { [key: string]: any } =
        group.generateCondition?.(filter) || {};
      const resp = await asyncGetList({
        apiCode: group.apiCode,
        withIdApp: true,
        applyToken: true,
        token,
        condition,
        stringifyData: false,
      });

      if (resp.status === 200) {
        const result = resp?.data || [];
        const min = result.shift()?.dongia || 0;
        const max = result.shift()?.dongia || 0;
        const average = result.shift()?.dongia || 0;
        const median = result.shift()?.dongia || 0;
        setSumary({ min, max, average, median });
        setData(result);
        setPaginationOption({
          ...paginationOption,
          totalRows: (result || [])?.length || 0,
        });
        setLoading(false);
      }
    } catch (error: any) {
      showAlert({
        type: "error",
        message:
          error?.data?.message || error?.data?.error || "Lỗi khi tải dữ liệu",
      });
    } finally {
    }
  };

  useEffect(() => {
    if (group.apiCode) {
      getListData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [load]);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundColor: "background.paper",
        borderRadius: "10px",
      }}
    >
      {/* Top */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          flexShrink: 0,
          height: heights.topList,
          px: 2,
          borderBottom: "1px dashed",
          borderColor: "divider",
        }}
      >
        <Typography
          sx={{ fontSize: "20px", lineHeight: "20px", fontWeight: 600 }}
        >
          {group?.title || "Danh sách"}
        </Typography>

        <Stack direction="row" alignItems="center" gap={1}>
          <Options group={group} setLoad={setLoad} />
          <IconButton
            onClick={() => setExpandFilter(!expandFilter)}
            sx={{
              borderRadius: "10px",
              color: "common.white",
              backgroundColor: "secondary.main",
              "&:hover": {
                backgroundColor: "secondary.main",
              },
            }}
          >
            <LuFilter size={16} />
          </IconButton>
        </Stack>
      </Stack>
      {/* Top end */}
      {/* Sumary */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        gap={1}
        sx={{
          height: heights.sumary,
          px: 2,
          borderBottom: "1px dashed",
          borderColor: "divider",
        }}
      >
        <Typography>
          Thấp nhất:{" "}
          <Typography
            component="span"
            sx={{ color: "error.main", fontWeight: 600 }}
          >
            {numeralCustom(sumary.min).format()}
          </Typography>{" "}
        </Typography>
        <Typography>
          Cao nhất:{" "}
          <Typography
            component="span"
            sx={{ color: "success.main", fontWeight: 600 }}
          >
            {numeralCustom(sumary.max).format()}
          </Typography>{" "}
        </Typography>
        <Typography>
          Trung bình:{" "}
          <Typography
            component="span"
            sx={{ color: "secondary.main", fontWeight: 600 }}
          >
            {numeralCustom(sumary.average).format()}
          </Typography>{" "}
        </Typography>
        <Typography>
          Trung vị:{" "}
          <Typography
            component="span"
            sx={{ color: "warning.main", fontWeight: 600 }}
          >
            {numeralCustom(sumary.median).format()}
          </Typography>{" "}
        </Typography>
      </Stack>
      {/* Sumary end */}
      <Box
        id="table-filter-layout"
        sx={{
          width: "100%",
          height: `calc(100vh - ${heights.header} - ${heights.py} - ${heights.topList} - ${heights.sumary})`,
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            width: `calc(100%${expandFilter ? ` - ${widthes.filter}` : ""})`,
            height: "100%",
            transition: "all 0.1s",
            transitionTimingFunction: "ease-out",
          }}
        >
          <TableClient
            progressPending={loading}
            columns={group.columns}
            data={data}
            fixedHeader
            pagination
            paginationComponentOptions={{
              rowsPerPageText: "Hàng trên trang",
              rangeSeparatorText: "/",
            }}
            // paginationComponent={({
            //   currentPage,
            //   onChangePage,
            //   onChangeRowsPerPage,
            //   rowCount,
            //   rowsPerPage,
            // }) => {
            //   return (
            //     <Box
            //       sx={{
            //         mt: "auto",
            //         borderTop: "1px dashed",
            //         borderColor: "divider",
            //         height: "42px",
            //       }}
            //     >
            //       <Tablepagination
            //         currentPage={currentPage}
            //         onChangePage={(value) => onChangePage(value, rowCount)}
            //         rowsPerPage={rowsPerPage || 10}
            //         rowCount={rowCount}
            //         onChangeRowsPerPage={(val) => {
            //           onChangeRowsPerPage(val, currentPage);
            //         }}
            //         paginationRowsPerPageOptions={[10, 20, 50, 100, 500]}
            //       />
            //     </Box>
            //   );
            // }}
            fixedHeaderScrollHeight={`calc(100vh - ${HEADER_HEIGHT} - ${heights.py} - ${heights.topList} - ${heights.sumary} - ${heights.pagination})`}
          />
        </Box>
        {/* Filter */}
        <Box
          sx={{
            height: "100%",
            width: expandFilter ? widthes.filter : "0px",
            transition: "all 0.1s",
            transitionTimingFunction: "ease-out",
            borderLeft: "2px solid",
            borderColor: expandFilter ? "primary.main" : "transparent",
            overflow: "hidden",
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{
              height: "40px",
              px: 2,
              borderBottom: "1px solid",
              borderColor: "divider",
            }}
          >
            <Typography sx={{ fontWeight: 600, color: "secondary.main" }}>
              Chế độ lọc
            </Typography>
          </Stack>
          <Box
            sx={{
              width: "100%",
              height: "calc(100% - 40px - 45px)",
              overflow: "auto",
              px: 2,
              py: 1,
            }}
          >
            {group.Filter && (
              <group.Filter filter={filter} setFilter={setFilter} />
            )}
          </Box>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            gap={1}
            sx={{
              height: "45px",
              borderTop: "1px dashed",
              borderColor: "divider",
            }}
          >
            <Button
              onClick={() => {
                setFilter({});
                setLoad(load + 1);
              }}
              variant="contained"
              size="small"
              color="secondary"
              sx={{
                textTransform: "none",
                color: "common.white",
                boxShadow: "none",
                "&:hover": { boxShadow: "none" },
              }}
            >
              Làm mới
            </Button>
            <Button
              onClick={() => setLoad(load + 1)}
              variant="contained"
              size="small"
              sx={{
                textTransform: "none",
                color: "common.white",
                boxShadow: "none",
                "&:hover": { boxShadow: "none" },
              }}
            >
              Lọc
            </Button>
            <Button
              onClick={() => setExpandFilter(false)}
              variant="contained"
              size="small"
              color="error"
              sx={{
                textTransform: "none",
                color: "common.white",
                boxShadow: "none",
                "&:hover": { boxShadow: "none" },
              }}
            >
              Đóng
            </Button>
          </Stack>
        </Box>
      </Box>
    </Box>
  );
}

export default GroupBase;
